export default __webpack_public_path__ + "media/components/ParallaxCrayon/crayon_7-b5be98f415996ea64c3c59cfa3e88c64.png";